import State from '../core/State';
import initialState from '../initialState';

export const setUploadedAdPlatformKeys = (id: string, keys: Array<string>) => (state: State): State => {
  const copy = new Map(state.creativeSending.uploadedAdPlatformKeys);
  return {
    ...state,
    creativeSending: {
      ...state.creativeSending,
      uploadedAdPlatformKeys: copy.set(id, keys),
    },
  };
};

export const setUploadedAdPlatformKeysMap = (uploadedAdPlatformKeysMap: Map<string, Array<string>>) => (
  state: State,
): State => ({
  ...state,
  creativeSending: {
    ...state.creativeSending,
    uploadedAdPlatformKeys: uploadedAdPlatformKeysMap,
  },
});

export const disposeCreativeSending = () => (state: State): State => ({
  ...state,
  creativeSending: initialState.creativeSending,
});
